import PageBannerCard from '@shared/components/core/card/PageBannerCard';
import { useTranslation } from 'react-i18next';
import LicenseKeySelectAccess from '../licenseKey/LicenseKeySelectAccess';

export default function ManagedOrgEmptyBanner() {
    const { t } = useTranslation();

    return (
        <PageBannerCard
            description={t('common:organization.managed.empty.description')}
            fullHeight
            title={t('common:organization.managed.empty.title')}>
            <LicenseKeySelectAccess />
        </PageBannerCard>
    );
}
